'use client';

import React from 'react';

import { Media } from '@/components/Media';
import { Gallery as UiGallery } from '@ui/gallery';
import type { Media as MediaType } from '@/payload-types';

export const Gallery: React.FC<{ title?: string; gallery: MediaType[] }> = ({
  title,
  gallery,
}) => {
  if (!gallery?.length) {
    return null;
  }

  return (
    <section
      className="container mt-[50px] mb-20 md:mt-8 md:mb-[70px]"
      data-name="Gallery"
    >
      {title && <h2 className="h2 mb-[43px] md:mb-6">{title}</h2>}

      <UiGallery className="grid grid-cols-2 justify-center gap-6 sm:grid-cols-1 md:gap-2">
        {gallery.map((image, idx, arr) => (
          <UiGallery.Item
            image={image}
            index={idx}
            totalCount={arr.length}
            toShow={2}
            key={image.id}
          >
            <Media
              className="aspect-676/408"
              imgClassName="corners"
              resource={image}
              fill
              size="medium"
            />
          </UiGallery.Item>
        ))}
      </UiGallery>
    </section>
  );
};
